import { render, staticRenderFns } from "./WelcomeTmp.vue?vue&type=template&id=b8528a3e&"
import script from "./WelcomeTmp.vue?vue&type=script&lang=ts&"
export * from "./WelcomeTmp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports